import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LocationInputContainer } from 'components/LocationInput/LocationInputContainer';
import { deepExtract } from 'helpers/deep';
export var LocationInputField =
/*#__PURE__*/
function (_Component) {
  _inherits(LocationInputField, _Component);

  function LocationInputField(props) {
    var _this;

    _classCallCheck(this, LocationInputField);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(LocationInputField).call(this, props));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleLoad = _this.handleLoad.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(LocationInputField, [{
    key: "handleChange",
    value: function handleChange(location) {
      var input = this.props.input;
      input.onChange(location); // "Touch" the field to trigger validation.

      input.onFocus();
      input.onBlur();
    }
  }, {
    key: "handleLoad",
    value: function handleLoad(location) {
      var input = this.props.input;
      input.onChange(location);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          input = _this$props.input,
          inputAttributes = _this$props.inputAttributes,
          label = _this$props.label,
          meta = _this$props.meta,
          suppressErrorMessage = _this$props.suppressErrorMessage,
          wrapperAttributes = _this$props.wrapperAttributes,
          wrapperTag = _this$props.wrapperTag;
      var hasError = meta.error && meta.touched;
      var inputElement = React.createElement(LocationInputContainer, {
        initialValue: deepExtract('location.name', input.value),
        inputAttributes: _objectSpread({}, inputAttributes, {
          className: classNames(inputAttributes.className, {
            'form__input--error': hasError
          })
        }),
        label: label,
        onChange: this.handleChange,
        onLoad: this.handleLoad
      });
      var errorElement;

      if (hasError) {
        errorElement = typeof meta.error === 'string' ? meta.error : React.createElement(FormattedMessage, meta.error);
      }

      return React.createElement(wrapperTag || 'div', wrapperAttributes || {}, inputElement, hasError && !suppressErrorMessage ? React.createElement("div", {
        className: "error__text text--sm mt-"
      }, errorElement) : null);
    }
  }]);

  return LocationInputField;
}(Component);
LocationInputField.propTypes = {
  input: PropTypes.shape({
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    value: PropTypes.object
  }),
  inputAttributes: PropTypes.object,
  meta: PropTypes.object,
  label: PropTypes.element,
  suppressErrorMessage: PropTypes.bool,
  wrapperAttributes: PropTypes.object,
  wrapperTag: PropTypes.string
};